import { useState, useEffect } from "react";
import { Icons, II } from "../../components/common/Icons";
import api from "../../services/api";
import EmpModal from "./EmpModal";import "../../assets/styles/Employee/EmpNotesPage.css";

const COLORS = ['#fef3c7', '#dbeafe', '#fce7f3', '#d1fae5', '#ede9fe', '#fee2e2'];

function EmpNotesPage({ notesApi }) {
  const [notes, setNotes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editNote, setEditNote] = useState(null);
  const [selColor, setSelColor] = useState('#fef3c7');

  const notesService = notesApi || {
    getNotes: api.getNotes,
    addNote: api.addNote,
    updateNote: api.updateNote,
    deleteNote: api.deleteNote
  };

  useEffect(() => {
    notesService.getNotes().then(setNotes).catch(() => {});
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = { title: fd.get("title"), content: fd.get("content"), color: selColor };
    try {
      if (editNote) {
        await notesService.updateNote(editNote.id, data);
        setNotes((prev) => prev.map((n) => n.id === editNote.id ? { ...n, ...data } : n));
      } else {
        const res = await notesService.addNote(data);
        setNotes((prev) => [{ id: res.id, ...data, created_at: new Date().toISOString() }, ...prev]);
      }
    } catch (e) {alert("Error: " + e.message);}
    setShowForm(false);setEditNote(null);setSelColor('#fef3c7');
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this note?")) return;
    try {await notesService.deleteNote(id);setNotes((prev) => prev.filter((n) => n.id !== id));}
    catch (e) {alert("Error: " + e.message);}
  };

  return (
    <div>
      <div className="empnotespage-inline-1">
        <div className="empnotespage-inline-2">{notes.length} notes</div>
        <button className="btn-primary" onClick={() => {setEditNote(null);setSelColor('#fef3c7');setShowForm(true);}}><Icons.Plus /> Add Note</button>
      </div>
      <div className="empnotespage-inline-3">
        {notes.map((n) =>
        <div key={n.id} className="card animate-in empnotespage-dyn-1" style={{ "--empnotespage-1-background": n.color || '#fef3c7', background: n.color || '#fef3c7' }}>
            <div className="card-body empnotespage-inline-4">
              <div className="empnotespage-inline-5">
                <div className="empnotespage-inline-6">{n.title || "Untitled"}</div>
                <div className="empnotespage-inline-7">
                  <button onClick={() => {setEditNote(n);setSelColor(n.color || '#fef3c7');setShowForm(true);}} className="empnotespage-inline-8" title="Edit note" aria-label="Edit note"><Icons.Edit /></button>
                  <button onClick={() => handleDelete(n.id)} className="empnotespage-inline-9" title="Delete note" aria-label="Delete note">{II('trash', 14)}</button>
                </div>
              </div>
              <div className="empnotespage-inline-10">{n.content}</div>
              {n.created_at && <div className="empnotespage-inline-11">{new Date(n.created_at).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })}</div>}
            </div>
          </div>
        )}
      </div>
      {notes.length === 0 && <div className="card empnotespage-inline-12"><div className="empnotespage-inline-13"><Icons.Clipboard /></div><div className="empnotespage-inline-14">No notes yet</div><div className="empnotespage-inline-15">Click "Add Note" to create your first note</div></div>}

      {showForm && <EmpModal title={editNote ? "Edit Note" : "New Note"} onClose={() => {setShowForm(false);setEditNote(null);}}>
        <form onSubmit={handleSave}>
          <div className="form-group"><label className="form-label">Title</label><input name="title" className="form-input" defaultValue={editNote?.title || ""} placeholder="Note title..." required /></div>
          <div className="form-group"><label className="form-label">Content</label><textarea name="content" className="form-input" rows={5} defaultValue={editNote?.content || ""} placeholder="Write your note..." required /></div>
          <div className="form-group"><label className="form-label">Color</label><div className="empnotespage-inline-16">
            {COLORS.map((c) => <div key={c} onClick={() => setSelColor(c)} style={{ "--empnotespage-2-background": c, "--empnotespage-2-border": selColor === c ? '3px solid #4f46e5' : '2px solid #cbd5e1', "--empnotespage-2-box-shadow": selColor === c ? '0 0 0 2px #c7d2fe' : 'none' }} className="empnotespage-dyn-2" />)}
          </div></div>
          <div className="form-actions"><button type="button" className="btn-outline" onClick={() => {setShowForm(false);setEditNote(null);}}>Cancel</button><button type="submit" className="btn-submit">Save</button></div>
        </form>
      </EmpModal>}
    </div>);

}

export default EmpNotesPage;

